import Axios from "axios";
import {
    SET_PROJECT_SUB_ACTIVITY_LIST,
    UNSET_PROJECT_SUB_ACTIVITY_LIST,
} from "@/store/mutation-types";
import { saveUpdateProjectSubActivity, getProjectSubActivityList } from "@/store/api";
// initial state
const state = {
    getProjectSubActivityList: [],
};

const getters = {
    getProjectSubActivityList(state) {
        return state.getProjectSubActivityList;
    },
};

const mutations = {
    [SET_PROJECT_SUB_ACTIVITY_LIST](state, data) {
        state.getProjectSubActivityList = data;
    },
    [UNSET_PROJECT_SUB_ACTIVITY_LIST](state) {
        state.getProjectSubActivityList = [];
    },

};

const actions = {

    saveUpdateProjectSubActivity({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateProjectSubActivity, data)
                .then(function (response) {
                resolve(response);
                })
                .catch(function (error) {

                reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
            });
    },

    getProjectSubActivityList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.post(getProjectSubActivityList, data)
                .then(function (response) {
                commit('SET_PROJECT_SUB_ACTIVITY_LIST', response.data.data)
                resolve(response);
                })
                .catch(function (error) {
                commit('UNSET_PROJECT_SUB_ACTIVITY_LIST')
                reject(error);
                })
                .then((always) => {
                });
            });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};